import React from 'react';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';

function ShareDropdown(props) {
  const {
    onGetLink,
    onGrantAccountAccess,
    downloadPdfHref,
    isQuote,
    showGrantAccessOption,
  } = props;
  return (
    <>
      <Dropdown drop="down-centered" className="d-inline ml-2 mb-3">
        <Dropdown.Toggle className="btn btn-secondary" aria-label="toggle columns menu">
          Share
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {
            isQuote && (
              <a href={downloadPdfHref} target="_blank" rel="noopener noreferrer" aria-label="download pdf file">
                <button
                  type="button"
                  className="dropdown-item"
                >
                  Download PDF
                </button>
              </a>
            )
          }
          <button
            onClick={onGetLink}
            type="button"
            className="dropdown-item"
          >
            Get Link
          </button>
          {showGrantAccessOption && (
            <button
              onClick={onGrantAccountAccess}
              type="button"
              className="dropdown-item"
            >
              Grant Account Access
            </button>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

ShareDropdown.defaultProps = {
  isQuote: false,
};

ShareDropdown.propTypes = {
  onGetLink: PropTypes.func.isRequired,
  onGrantAccountAccess: PropTypes.func.isRequired,
  downloadPdfHref: PropTypes.string.isRequired,
  isQuote: PropTypes.bool,
  showGrantAccessOption: PropTypes.bool.isRequired,
};

export default ShareDropdown;
